import request from "@/plugins/axios"
//上传汇总任务
let prefix = "eids-invoice/tcs/stat";

export function getSalesStat(nsrsbh) {
  return request({
    url: prefix + '/getSalesStat?nsrsbh='+nsrsbh,
    method: 'get',
    
  })
}

export function getDeductStat(nsrsbh) {
  return request({
    url: prefix + '/getDeductStat?nsrsbh='+nsrsbh,
    method: 'get',
    
  })
}

export function getProductStat(nsrsbh,ssflbm) {
  return request({
    url: prefix + '/getProductStat',
    method: 'post',
    data:{
      'nsrsbh':nsrsbh,
      'ssflbm':ssflbm
    }
  })
}
//获取stackStae
export function getStackStat(nsrsbh) {
  return request({
    url: prefix + '/getStackStat?nsrsbh='+nsrsbh,
    method: 'get',
    
  })
}

export function getSummaryStat(nsrsbh) {
  return request({
    url: prefix + '/getSummaryStat?nsrsbh='+nsrsbh,
    method: 'get',
    
  })
}